// This icon file is generated automatically.
var PVerticalLeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M9.9.56h-1a.13.13 0 00-.12.13v10.75c0 .07.06.12.13.12h1c.06 0 .12-.05.12-.12V.69a.13.13 0 00-.12-.13zm-7.93 0V1.7c0 .15.06.3.18.39L6.82 6 2.15 9.92a.5.5 0 00-.18.39v1.13c0 .1.12.16.2.1L8.77 6 2.17.47a.12.12 0 00-.2.1z", "fill-rule": "nonzero" } }] }, "name": "p-vertical-left", "theme": "outlined" };
export default PVerticalLeftOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PVerticalLeftOutlined.js
// module id = 3722
// module chunks = 0